import { useEffect } from "react";

const FlumeterRedirect = () => {
  useEffect(() => {
    window.location.href =
      "https://idp.uhg.com/flumeter";
  }, []);

  return <div>Redirecting...</div>;
};

export default FlumeterRedirect;